import type { JohnDeereOrganization } from 'types/johnDeere';

import { createSlice } from '@reduxjs/toolkit';

type JohnDeereState = {
    accessToken: string | null;
    connectedOrgs: JohnDeereOrganization[];
    isConnecting: boolean;
    refreshToken: string | null;
    tokenExpiry: number | null;
};

const initialState: JohnDeereState = {
    accessToken: null,
    connectedOrgs: [],
    isConnecting: false,
    refreshToken: null,
    tokenExpiry: null
};

export const slice = createSlice({
    initialState,

    name: 'useJohnDeere',

    reducers: {
        clearTokens: state => {
            state.accessToken = null;
            state.connectedOrgs = [];
            state.isConnecting = false;
            state.refreshToken = null;
            state.tokenExpiry = null;
        },

        setConnectedOrgs: (state, action) => {
            state.connectedOrgs = action.payload;
        },

        setIsConnecting: (state, action) => {
            state.isConnecting = action.payload;
        },

        setTokens: (state, action) => {
            state.accessToken = action.payload.accessToken;
            state.refreshToken = action.payload.refreshToken;
            state.tokenExpiry = action.payload.tokenExpiry;
        }
    }
});

export const selectIsJohnDeereConnected = (state: { useJohnDeere: JohnDeereState }): boolean => {
    const { accessToken, tokenExpiry } = state.useJohnDeere;

    if (!accessToken || !tokenExpiry) {
        return false;
    }

    return Date.now() < tokenExpiry;
};

export const selectJohnDeereAccessToken = (state: {
    useJohnDeere: JohnDeereState;
}): string | null => state.useJohnDeere.accessToken;

export const selectJohnDeereRefreshToken = (state: {
    useJohnDeere: JohnDeereState;
}): string | null => state.useJohnDeere.refreshToken;

export const selectJohnDeereOrgs = (state: {
    useJohnDeere: JohnDeereState;
}): JohnDeereOrganization[] => state.useJohnDeere.connectedOrgs;

export const selectIsJohnDeereConnecting = (state: { useJohnDeere: JohnDeereState }): boolean =>
    state.useJohnDeere.isConnecting;

export default slice.reducer;
